import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { StatusMark } from "./kit";
import { fmtTgl } from "../lib/api";

export default function BukuView({ data, hanyaTakBertuan }) {
  const [sistemTerbuka, setSistemTerbuka] = useState(null);
  if (!data?.length) return null;
  return (
    <div className="space-y-3">
      {data.map((s) => {
        const rows = hanyaTakBertuan ? s.akses.filter((a) => a.status === "TAK_BERTUAN") : s.akses;
        const terbuka = sistemTerbuka === s.sistem_id;
        return (
          <section key={s.sistem_id} data-testid={`buku-sistem-${s.sistem_id}`} className="panel rounded overflow-hidden">
            <button
              type="button"
              data-testid={`buka-detail-sistem-${s.sistem_id}`}
              aria-expanded={terbuka}
              onClick={() => setSistemTerbuka(terbuka ? null : s.sistem_id)}
              className="flex w-full flex-wrap items-center gap-x-5 gap-y-1.5 p-4 text-left transition-colors duration-150 hover:bg-secondary/60"
            >
              <span className="font-heading font-semibold">{s.label}</span>
              <span className="text-xs text-muted-foreground">{s.kategori}</span>
              <span className="text-xs text-muted-foreground">
                Penanggung jawab: {s.pemilik_nama || <span className="text-destructive font-medium">belum ditunjuk</span>}
              </span>
              <span className="text-xs font-data text-muted-foreground">
                {s.jumlah_terbuka} masih terbuka · {s.jumlah_tak_bertuan} tanpa pemilik
              </span>
              <span className="ml-auto text-xs text-muted-foreground">Terakhir dicek: {fmtTgl(s.terakhir_disapu)}</span>
              <span className="inline-flex items-center gap-1 text-xs font-medium text-primary">
                {terbuka ? "Sembunyikan" : "Lihat isinya"}
                <ChevronDown size={16} aria-hidden="true" className={`transition-transform duration-200 ${terbuka ? "rotate-180" : ""}`} />
              </span>
            </button>
            {terbuka && (
              rows.length === 0 ? (
                <p className="border-t p-4 text-sm text-muted-foreground">Tidak ada akun yang masih terbuka di sini.</p>
              ) : (
                <div className="overflow-x-auto border-t">
                  <table className="w-full text-sm border-collapse">
                    <thead>
                      <tr className="bg-muted/60">
                        {["Keadaan", "Orang", "Haknya", "Dibuka", "Umur", "Ditemukan dari"].map((h) => (
                          <th key={h} className="text-left p-2.5 label-kecil font-normal">{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((a) => (
                        <tr key={a.id} data-testid={`akses-${a.id}`}
                          className={`border-t ${a.status === "TAK_BERTUAN" ? "bg-destructive/5" : ""}`}>
                          <td className="p-2.5"><StatusMark status={a.status} testid={`status-akses-${a.status}`} /></td>
                          <td className="p-2.5"><span className="font-data">{a.orang_kode}</span> — {a.orang_nama}</td>
                          <td className="p-2.5">{a.hak}</td>
                          <td className="p-2.5 tabular">{fmtTgl(a.dibuka_pada)}</td>
                          <td className="p-2.5 font-data">
                            {a.umur_tak_bertuan_hari != null ? `${a.umur_tak_bertuan_hari} hari` : "—"}
                          </td>
                          <td className="p-2.5 text-xs text-muted-foreground">{a.sumber_penemuan}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )
            )}
          </section>
        );
      })}
    </div>
  );
}
